export default [{
  city: 'hrb',
  cityName: '哈尔滨',
  sellerPlace: '哈尔滨',
  sellerCarType: '起亚瑞欧车主',
  sellerName: '钱先生',
  sellerSay: '开了几年，和车都有感情了，虽然不舍，还是得换车，感谢人人车帮我找了个爱惜车的买主。'
}, {
  city: 'cc',
  cityName: '长春',
  sellerPlace: '长春',
  sellerCarType: '奇瑞旗云车主',
  sellerName: '王先生',
  sellerSay: '不太喜欢砍价，人人车的评估师给了一个评估价格，就按照这个价卖了。和人人车说了不还价，如果要砍价的就不看了，就看了一次，买家也挺干脆的，现场就拍板了，比较顺利。'
}, {
  city: 'dl',
  cityName: '大连',
  sellerPlace: '大连',
  sellerCarType: '马自达6车主',
  sellerName: '连先生',
  sellerSay: '人人车给估的价，比车商那边高了快1万，二手车的水真是深啊，幸好没有被骗。最后顺利在人人车卖了车，价格靠谱！'
}, {
  city: 'bj',
  cityName: '北京',
  sellerPlace: '北京',
  sellerCarType: '奔驰C系车主',
  sellerName: '连先生',
  sellerSay: '车子开了三年多，一直在4S店保养，家里添了小朋友，想换个SUV。4S店给的置换价格低的离谱，干脆挂在网上卖了，没想到人人车这么靠谱，一周就成交了，价格也比4S店高10%以上。'
}, {
  city: 'tj',
  cityName: '天津',
  sellerPlace: '天津',
  sellerCarType: '宝马X3车主',
  sellerName: '杜先生',
  sellerSay: '不太清楚二手车的行情，人人车评估师帮忙估的价格，比较合理。卖车期间，车子也不用寄存，买家直接来公司看车，很方便。'
}, {
  city: 'qd',
  cityName: '青岛',
  sellerPlace: '青岛',
  sellerCarType: '比亚迪S6车主',
  sellerName: '方女士',
  sellerSay: '前前后后一个礼拜，看了三四次，因为都是来家里看车，不耽误事儿。最后的手续都是人人车给办的，我就去过了下户，现在的平台做的真是不错。'
}, {
  city: 'wf',
  cityName: '潍坊',
  sellerPlace: '潍坊',
  sellerCarType: '福特蒙迪欧车主',
  sellerName: '管先生',
  sellerSay: '投资需要追加保证金，只能先把车卖了，只求价高速度快！要求人人车给加急处理，3天卖车的钱就到帐了，价格比拍卖和车商都高！'
}, {
  city: 'sh',
  cityName: '上海',
  sellerPlace: '上海',
  sellerCarType: '三菱翼神车主',
  sellerName: '党先生',
  sellerSay: '只见了一个看车的，价格谈妥就去过户了，手续人人车跑，还送了我些小礼品，买家对人人车印象也不错！'
}, {
  city: 'hz',
  cityName: '杭州',
  sellerPlace: '杭州',
  sellerCarType: '丰田雅力士车主',
  sellerName: '罗先生',
  sellerSay: '今年年终奖不错，先把雅力士卖了，准备去提个宝马。人人车的服务不错，买家都是过来看车，过户带齐证件，人人车就给代办了，整个过程没费什么功夫。'
}, {
  city: 'nj',
  cityName: '南京',
  sellerPlace: '南京',
  sellerCarType: '本田雅阁车主',
  sellerName: '张先生',
  sellerSay: '二手车市场就是一趟浑水，经常不小心就着了道。这次卖车选择人人车，就是不想被车商、4S店去赚差价，自己可以多卖点！事实证明，人人车的价格相当靠谱！'
}, {
  city: 'xm',
  cityName: '厦门',
  sellerPlace: '厦门',
  sellerCarType: '海马福美来车主',
  sellerName: '崔女士',
  sellerSay: '车子买的比较早，在多个平台都挂了信息，最后人人车的买家来的比较快，看了几次就成交了！'
},
{
  city: 'fz',
  cityName: '福州',
  sellerPlace: '福州',
  sellerCarType: '长安奔奔车主',
  sellerName: '董先生',
  sellerSay: '朋友推荐我来人人车卖车，说比二手车市场价格高，服务也更好。确实不错，价格比市场上高了大几千，卖的也很快。'
}, {
  city: 'hf',
  cityName: '合肥',
  sellerPlace: '合肥',
  sellerCarType: '丰田卡罗拉车主',
  sellerName: '杨先生',
  sellerSay: '我的车去年刚上牌，家里急用钱才卖的，挂了两天就卖了，钱也顺利到账，没耽误家里用钱，感谢人人车！'
}, {
  city: 'zz',
  cityName: '郑州',
  sellerPlace: '郑州',
  sellerCarType: '雪佛兰景程车主',
  sellerName: '李先生',
  sellerSay: '还没想好换什么车，先挂在人人车上试着卖，没想到几天就卖掉了。卖车过程比较省心，买车的人来家里看车，看了2次就卖掉了，过户也没费劲。打算在人人车买辆准新车，感觉靠谱！'
}, {
  city: 'wh',
  cityName: '武汉',
  sellerPlace: '武汉',
  sellerCarType: '大众甲壳虫车主',
  sellerName: '严女士',
  sellerSay: '以前用来上下班的，现在换了工作单位，离家很近，家里还有一辆SUV，感觉用不上了，卖给更需要它的姑娘，希望买家继续珍惜爱护它！'
}, {
  city: 'yc',
  cityName: '宜昌',
  sellerPlace: '宜昌',
  sellerCarType: '奇瑞瑞虎车主',
  sellerName: '刘先生',
  sellerSay: '本来是朋友要在人人车买车，陪着看了几次车，车况都不错，搞得我也想换车。冲动之下，一口气就卖了！现在的任务是，再在人人车买一辆！'
}, {
  city: 'cs',
  cityName: '长沙',
  sellerPlace: '长沙',
  sellerCarType: '吉利英伦车主',
  sellerName: '陈先生',
  sellerSay: '比卖给车行的价格高，比我预期的价格高了不少！买家也挺干脆的，当天就去过户了！'
}, {
  city: 'cq',
  cityName: '重庆',
  sellerPlace: '重庆',
  sellerCarType: '雪佛兰赛欧车主',
  sellerName: '赵先生',
  sellerSay: '我车子在4S店保养，一直很爱惜，本来想在4S店置换，置换的价格比较低，电视上看到人人车广告，试着打了个电话问问，人人车的客服很热情，最后卖的价格很满意！'
}, {
  city: 'xt',
  cityName: '湘潭',
  sellerPlace: '湘潭',
  sellerCarType: '斯柯达明锐车主',
  sellerName: '魏先生',
  sellerSay: '人人车确实比车行卖的价格高，而且不用寄卖，不影响平时用车。带来的买家也都靠谱，看了2次就卖掉了，过户还不用自己跑。'
}, {
  city: 'dg',
  cityName: '东莞',
  sellerPlace: '东莞',
  sellerCarType: '雪铁龙C4L车主',
  sellerName: '吴先生',
  sellerSay: '我的车保险快到期了，不打算续保了，要赶紧卖了换车。人人车效率挺高的，当天就有人来看车，第二天就卖掉了！'
}, {
  city: 'gz',
  cityName: '广州',
  sellerPlace: '广州',
  sellerCarType: '本田雅阁车主',
  sellerName: '宫先生',
  sellerSay: '跟老婆在人人车看上了一辆极光，顺手就把老车在人人车卖了，卖的价格不错！'
}, {
  city: 'fs',
  cityName: '佛山',
  sellerPlace: '佛山',
  sellerCarType: '奇瑞瑞虎车主',
  sellerName: '范女士',
  sellerSay: '自己不太敢去二手车市场卖车，比较乱，车行给的价格又太低。网上搜到的人人车，正好佛山有分站，挂到人人车上，第二天就有人要来看车！'
}, {
  city: 'xa',
  cityName: '西安',
  sellerPlace: '西安',
  sellerCarType: '福特福克斯车主',
  sellerName: '姜先生',
  sellerSay: '福特的车动力好，开着爽快，打算卖了换个动力更好的。人人车的评估师先来看了车，当天在网站上就看到我的车了，不到一周就卖掉了，价格也很满意。'
}]
